<template>
    <button class="ui-button" @click="$emit('click')">
        <ui-icon v-if="iconLeft" :name="iconLeft" class="ui-button__icon left" />
        <slot>
            <slot name="title" tag="span" class="ui-button__label">{{ title }}</slot>
        </slot>
        <ui-icon v-if="iconRight" :name="iconRight" class="ui-button__icon left" />
    </button>
</template>

<script>
    export default {
        name: 'ui-button',
        props: ['title', 'iconLeft', 'iconRight'],
    }
</script>

<style>
    .ui-button {
        background-color: #2b75bb;
        border-radius: 6px;
        color:#ffffff;
        border: 0;
        outline: 0;
        padding: 0px 15px 0px 15px;
        font-weight: 500;
        font-size: 1em;
        line-height: 24px;
        justify-content: center;
        text-align: center;
    }

    .ui-button:hover {
        opacity: .8;
    }

    .ui-button:active {
        opacity: 1;
    }

    .ui-button__icon.left {
        margin-right: 6px;
    }

    .ui-button__icon.right {
        margin-left: 6px;
    }

    .ui-button__icon {

    }
</style>



// WEBPACK FOOTER //
// UiButton.vue?803d6df8